import { Button, Card, Heading, Stack, Text } from "@softmax/design-system";

export function SavedMaps({ onDownload }: { readonly onDownload: () => void }) {
  return (
    <Card>
      <Stack width="auto">
        <Heading level={2}>Saved maps</Heading>
        <Text as="p" size="small" tone="muted">
          Download maps saved in this browser before Map Studio retired.
        </Text>
        <div>
          <Button type="button" size="sm" onClick={onDownload}>
            Download saved maps
          </Button>
        </div>
      </Stack>
    </Card>
  );
}
